var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-screen px-10 w-1/2 justify-items-center items-center"})}
var staticRenderFns = []

export { render, staticRenderFns }